
const lastUpdate = '2026-03-15';
export const helpTitle = 'Station Create / Edit Form';

export const helpContent = `
<h1>${helpTitle}</h1>

<h2>Overview</h2>
<p>The Station Form is used to create a new weather station or edit an existing one. Fields are organized into sections for identification, location, hardware, operations, and contacts.</p>

<h2>Station Identification</h2>
<ul>
  <li><strong>NESDIS Code</strong> — The unique identifier assigned by NESDIS (NOAA). Required for data ingestion.</li>
  <li><strong>Name</strong> — The station's display name as it appears throughout EasyMap.</li>
  <li><strong>Region</strong> — The management region this station belongs to.</li>
</ul>

<h2>Location</h2>
<ul>
  <li><strong>Coordinates</strong> — Latitude and longitude of the station in decimal degrees.</li>
  <li><strong>Elevation</strong> — Station elevation in metres above sea level. Used in CFFDRS calculations.</li>
</ul>

<h2>Hardware</h2>
<ul>
  <li><strong>Sensor Suite</strong> — Configure which sensors are active on this station (temperature, humidity, wind, precipitation, etc.).</li>
</ul>

<h2>Operations</h2>
<ul>
  <li><strong>CFFDRS Mode</strong> — Set the station's CFFDRS operating mode (e.g., active, inactive).</li>
  <li><strong>Fuel Type</strong> — The predominant fuel type at the station location, used in fire weather calculations.</li>
</ul>

<h2>Contact Information</h2>
<p>Enter contact details for the person or team responsible for maintaining this station.</p>

<div class="last-update">Last Updated: ${lastUpdate}</div>
`;

export default helpContent;
